var exports = {
  "h_": "GiftSendToFriendModal.module__description___N3U0SF",
  "jo": "GiftSendToFriendModal.module__sendButton___N3U0SF",
  "Zw": "GiftSendToFriendModal.module__giftCodeText___N3U0SF",
  "A4": "GiftSendToFriendModal.module__giftCode___N3U0SF",
};

module.exports = exports;
